import Loading from 'components/Loading';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import React, { Component } from 'react';
import { downloadPdf, downloadPdfService } from 'services/API';
import Warning from '../../../../components/Warning';

import './styles.scss';
import REACT_CONFIG from 'REACT_CONFIG';

const fileSaver = require('file-saver');

export default class PreviewAndDownloadPdf extends Component {
  static propTypes = {
    filename: PropTypes.string.isRequired,
    pdf: PropTypes.string,
    url: PropTypes.string,
    documentNumber: PropTypes.string,
  };

  static defaultProps = {
    filename: 'file.pdf',
  };

  state = {
    error: false,
    pdfSource: null,
    loading: true,
    downloadLoading: false,
  };

  async componentDidMount() {
    const { pdf, url } = this.props;
    const PDFJS = await import('pdfjs-dist');
    const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker.entry');
    const PDFViewer = await import('pdfjs-dist/web/pdf_viewer');
    await import('pdfjs-dist/web/pdf_viewer.css');
    PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;

    let pdfPromise;
    if (url) {
      pdfPromise = downloadPdf(url);
    } else {
      pdfPromise = downloadPdfService(pdf);
    }

    pdfPromise
      .then((res) => {
        if (res.isOk) {
          return res.data;
        }

        throw res.error;
      })
      .then((pdfData) => {
        if (pdfData.byteLength > +REACT_CONFIG.REACT_APP_FILE_PREVIEW_LIMIT) {
          const filename = pdf;
          const blob = new Blob([pdfData], {
            type: 'application/pdf;charset=utf-8',
          });

          fileSaver.saveAs(blob, filename, true);
          return null;
        } else {
          this.setState({ pdfData });
          return PDFJS.getDocument(pdfData).promise;
        }
      })
      .then((result) => {
        if (result === null) {
          this.setState({
            loading: false,
          });
        } else {
          this.setState(
            {
              loading: false,
              pdfSource: result,
            },
            () => {
              const eventBus = new PDFViewer.EventBus();
              const pdfService = new PDFViewer.PDFViewer({
                container: this.refs.pdfPreview,
                eventBus,
              });
              pdfService.setDocument(result);
            },
          );
        }
      })
      .catch((err) => {
        window.console.error(err);
        this.setState({
          error: true,
          loading: false,
        });
      });
  }

  getTitle = () => {
    const { pdf = '', documentNumber, filename = '' } = this.props;
    const number = get(filename.match(/-(.*?)\./), [1]);
    const type = get(pdf.match(/^(.*?)\//), [1]);
    let titleTxt;
    switch (type) {
      case 'snu':
        titleTxt = 'Налоговое уведомление';
        break;
      case 'demand':
        titleTxt = 'Требование об уплате';
        break;
      case 'courtOrder':
        titleTxt = 'Заявление о вынесении судебного приказа';
        break;
    }
    if (titleTxt && documentNumber) {
      return `${titleTxt}${` №${documentNumber}`}`;
    }
    if (titleTxt) {
      return `${titleTxt}${number ? ` №${number}` : ''}`;
    }
  };

  downloadPdf = () => {
    const { filename } = this.props;
    const blob = new Blob([this.state.pdfData], {
      type: 'application/pdf;charset=utf-8',
    });

    fileSaver.saveAs(blob, filename, true);
  };

  renderPreview = () => {
    const { pdfSource } = this.state;

    if (!pdfSource) {
      return null;
    }

    return (
      <div className="white-block white-block__pad30 boo">
        <div className="page_margin30">
          {this.state.downloadLoading ? (
            <div className="loading-container loading-container__inline">
              <Loading />
            </div>
          ) : (
            <div className="link link_pdf">
              <a onClick={this.downloadPdf}>Сохранить в PDF</a>
            </div>
          )}
        </div>
        <div ref="pdfPreview" className="pdf-preview-wrapper overflow-auto">
          <div id="viewer" className="pdfViewer" />
        </div>
      </div>
    );
  };

  render() {
    const { filename } = this.props;
    const { loading, error } = this.state;

    return (
      <div className="page">
        <div className="page-title">
          <div className="page-title_block">
            <h1>{this.getTitle() || filename}</h1>
          </div>
        </div>
        {!loading && error ? <Warning message="Ошибка формирования документа." /> : null}
        {loading && !error ? <Loading /> : null}
        {!loading && !error ? this.renderPreview() : null}
      </div>
    );
  }
}
